import { Rule } from '../../../../../store/modules/rules';

const getRuleFieldValue = <T extends unknown>(rule: Rule, name: string): T | undefined => (
  rule[name] as T || undefined
);

export default getRuleFieldValue;
